import { render, staticRenderFns } from "./lightbox-block.vue?vue&type=template&id=49017b9a&"
import script from "./lightbox-block.vue?vue&type=script&lang=js&"
export * from "./lightbox-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49017b9a')) {
      api.createRecord('49017b9a', component.options)
    } else {
      api.reload('49017b9a', component.options)
    }
    module.hot.accept("./lightbox-block.vue?vue&type=template&id=49017b9a&", function () {
      api.rerender('49017b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/lightbox-block.vue"
export default component.exports